
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import Message from '@/components/message.vue';
	import PageFooter from '@/components/page-footer.vue';
	import {
		getBackendAnnouncementList,
		setAnnouncement,
		delAnnouncement
	} from '@/api/material'
	import Switch from '@/components/switch.vue';

	@Component({
		name: 'notice-list',
		components: {
			PageFooter,
			'slz-switch': Switch,
			Message
		}
	})
	export default class NoticeList extends Vue {
		private list: any = []
		private pageNo = 1
		private pageSize = 10
		private total = 0
		private showDialog = false
		private currentId = 0

		private mounted() {
			// console.log(this.pageNo)
			this.getList()
		}

		private toCreate() {
			this.$router.push({
				name: 'Notice_Detail',
				query: {
					type: 'new'
				}
			})
		}

		private toEdit(id: number) {
			this.$router.push({
				name: 'Notice_Detail',
				query: {
					type: 'edit',
					id: id + ''
				}
			})
		}

		private changePage(num: number) {
			this.pageNo = num;
			// console.log(num)
			this.getList()
		}

		private async getList() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize
			}
			try {
				const res: any = await getBackendAnnouncementList(params);
				this.list = res.Result.Results || [];
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			}
		}

		private async changeState(e: any, data: any) {
			try {
				await setAnnouncement({
					Id: data.Id
				})
				this.$message({
					type: 'success',
					message: '设置成功'
				})
			} catch (e) {
				console.log(e)
			}
			console.log(e, data)
		}

		// 删除
		private del(id: number) {
			this.showDialog = true;
			this.currentId = id;
		}

		// 确认删除
		private async confirmDelete() {
			try {
				await delAnnouncement({
					id: +this.currentId,
				})
				this.$message({
					type: 'success',
					message: '删除成功'
				})
				this.pageNo = 1
				this.getList();
			} catch (e) {
				console.log('deleteMaterial ===>', e)
			}
		}
	}
